import { authClient, API } from "../index";

// Get all backtestingResults
export const getBacktestingResults = () => {
  return authClient().get(`${API}/backtesting-results?getDisabled=true`);
};

// Get backtestingResult by id
export const getBacktestingResultById = (id) => {
  return authClient().get(`${API}/backtesting-results/${id}`);
};

// Delete backtestingResult
export const deleteBacktestingResult = (id) => {
  return authClient().delete(`${API}/backtesting-results/${id}`);
};

// Create backtestingResult
export const postBacktestingResult = async (backtestingResult) => {
  return authClient().post(`${API}/backtesting-results`, backtestingResult);
};

// Update backtestingResult
export const updateBacktestingResult = async (id, backtestingResult) => {
  return authClient().put(`${API}/backtesting-results/${id}`, backtestingResult);
};

// Change status backtestingResult
export const changeStatusBacktestingResult = async (id, active) => {
  console.log("id", id, "active", active);
  return authClient().put(`${API}/backtesting-results/change-status/${id}`, { active });
};
